import Point = Phaser.Point;
import Tilemap = Phaser.Tilemap;
import Tile = Phaser.Tile;
import {LevelLoader} from "./levelloader";
import {Texter} from "./texter";
import TilemapLayer = Phaser.TilemapLayer;
/**
 * Represents a player
 */
var textX;
var textY;
export class Player {
    public key: boolean;
    won: boolean;
    currentTile: Tile;


    constructor(public game: Phaser.Game, public levelloader: LevelLoader, public texter: Texter) {
        textX = this.game.width/2 -190;
        textY = 535;
    }

    // Moves Player to Position + Layer
    move(position: Point, layer: number) {
        let target = this.levelloader.getTile(position.x, position.y, layer);
        if (target !== null) {
            // Check if it's possible to move on target Tile
            if (!this.checkTargetMovableTo(target)) {
                return;
            }
            // Exchanges the two tiles and loads the layer if changed
            this.levelloader.switchTiles(this.currentTile, target, layer);

            // Save the current Tile
            this.currentTile = target;
        }
    }

    checkTargetMovableTo(target: Tile): boolean {
        switch (target.index) {
            // Wall tile
            case 5:
                this.texter.render("The way is blocked!", textX, textY);
                return false;
            // Finishing tile
            case 4:
                this.won = true;
                return true;
            // Key tile
            case 3:
                if(this.key) {
                    this.texter.render("You can only carry one key!", textX, textY);
                    return false;
                }
                this.texter.render("You found a key!", textX, textY);
                this.key = true;
                return true;
            // Ground tile
            case 1:
                this.texter.render("", textX, textY);
                return true;
            // Door tile
            case 7:
                if (this.key) {
                    this.key = false;
                    this.texter.render("You opend a door!", textX, textY);
                    return true;
                } else {
                    this.texter.render("The door is closed!", textX, textY);
                    return false;
                }
        }
    }

    loadNewLevel(startTile: Tile) {
        this.currentTile = startTile;
        this.currentTile.index = 2;
        this.won = false;
        this.key = false;
    }
}


// WEBPACK FOOTER //
// ./src/player.ts